import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../services/api";
import Logo from "../assests/logo.png";
import Visa from "../assests/paymentcards.png";
import Img1 from "../assests/icons/2.png";
import Img2 from "../assests/icons/3.png";
import Img3 from "../assests/icons/4.png";
import Img4 from "../assests/icons/5.png";

function Footer() {
    const [newsletterEmail, setNewsletterEmail] = useState("");
    const [newsletterStatus, setNewsletterStatus] = useState({ type: "", message: "" });
    const [newsletterLoading, setNewsletterLoading] = useState(false);

    const submitNewsletter = async (event) => {
      event.preventDefault();
      setNewsletterStatus({ type: "", message: "" });
      const email = newsletterEmail.trim();

      if (!/^\S+@\S+\.\S+$/.test(email)) {
        setNewsletterStatus({ type: "error", message: "Please enter a valid email address." });
        return;
      }

      try {
        setNewsletterLoading(true);
        const data = await api.post("/newsletter/subscribe", { email, source: "footer" });
        setNewsletterEmail("");
        setNewsletterStatus({ type: "success", message: data.message || "Thanks for subscribing." });
      } catch (err) {
        setNewsletterStatus({ type: "error", message: err.message || "Subscription failed. Please try again." });
      } finally {
        setNewsletterLoading(false);
      }
    };

    const footerStyle = {
  background: "#f8fafc",
  padding: "30px 0 10px",
  fontFamily: "DM Sans, sans-serif",
};

const topSection = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 20,
};

const logoBox = {};

const socialBox = {
  display: "flex",
  alignItems: "center",
  gap: 10,
};

const socialText = {
  fontSize: 12,
  color: "#64748b",
};

const socialIcons = {
  display: "flex",
  gap: 8,
};

const icon = {
  width: 24,
  height: 24,
  borderRadius: "50%",
  background: "#e2e8f0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
};

const middleSection = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 20,
  borderTop: "1px solid #e2e8f0",
  paddingTop: 20,
};

const heading = {
  fontSize: 14,
  fontWeight: "800",
  marginBottom: 10,
  color: "#3991D5",
  fontFamily: "Gopher",
};

const newsletterBox = {
  background: "#eef2f7",
  padding: 15,
  borderRadius: 10,
};

const inputRow = {
  display: "flex",
  marginTop: 10,
};

const inputStyle = {
  flex: 1,
  padding: "8px 15px",
  fontSize: 12,
  border: "1px solid #cbd5f5",
  borderRadius: "20px 0 0 20px",
  outline: "none",
};

const btnStyle = {
  background: "#3991D5",
  color: "#fff",
  border: "none",
  fontSize: 12,
  padding: "8px 14px",
  borderRadius: "0 20px 20px 0",
  cursor: "pointer",
};

const payments = {
  display: "flex",
  gap: 6,
  flexWrap: "wrap",
};

const linkStyle = {
  color: "inherit",
  display: "block",
  margin: "1em 0",
  textDecoration: "none",
};

const bottomSection = {
  marginTop: 20,
  paddingTop: 10,
  borderTop: "1px solid #e2e8f0",
  display: "flex",
  justifyContent: "space-between",
  fontSize: 12,
  color: "#64748b",
};
  return (
    <footer style={footerStyle}>
      <div className="container">

        {/* Top Section */}
        <div style={topSection}>

          {/* Logo */}
          <div style={logoBox}>
            <img src={Logo} alt="logo" style={{ height: 50 }} />
          </div>

          {/* Social */}
          <div style={socialBox}>
            <span style={socialText}>Social Links :</span>
            <div style={socialIcons}>
              <span style={icon}><img src={Img1} alt="" /></span>
              <span style={icon}><img src={Img2} alt="" /></span>
              <span style={icon}><img src={Img3} alt="" /></span>
              <span style={icon}><img src={Img4} alt="" /></span>
            </div>
          </div>

        </div>

    
        <div style={middleSection}>

     
          <div>
            <h4 className="footer-heading" style={heading}>Main Links</h4>
            <Link to="/" style={linkStyle}>Home</Link>
            <Link to="/all-products" style={linkStyle}>Shop</Link>
            <Link to="/about" style={linkStyle}>About Us</Link>
            <Link to="/terms-and-conditions" style={linkStyle}>Terms</Link>
            <a  href="/blogs" style={linkStyle}>Blogs</a>
          </div>

          {/* Shop */}
          <div>
            <h4 className="footer-heading" style={heading}>Shop</h4>
            <p>Pegasus Parts</p>
            <p>Juki Machine & Parts</p>
            <p>Ever Peak Brand</p>
            <p>Part Book PDF</p>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="footer-heading" style={heading}>Useful Links</h4>
            <Link to="/terms-and-conditions" style={linkStyle}>Terms & Conditions</Link>
            <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
            <Link to="/refund-policy" style={linkStyle}>Refund Policy</Link>
            <Link to="/support" style={linkStyle}>Support</Link>
          </div>

          {/* Newsletter */}
          <div style={newsletterBox}>
            <h4 style={heading}>Subscribe Newsletter</h4>
            <p style={{ fontSize: 12, color: "#64748b" }}>
              Join our mailing list to receive only latest updates and promotions.
            </p>

            <form style={inputRow} onSubmit={submitNewsletter}>
              <input
                type="email"
                placeholder="Your email address"
                style={inputStyle}
                value={newsletterEmail}
                onChange={(event) => setNewsletterEmail(event.target.value)}
                disabled={newsletterLoading}
              />
              <button style={{ ...btnStyle, opacity: newsletterLoading ? 0.7 : 1 }} disabled={newsletterLoading} type="submit">
                {newsletterLoading ? "Saving..." : "Sign Up"}
              </button>
            </form>
            {newsletterStatus.message && (
              <p
                style={{
                  color: newsletterStatus.type === "error" ? "#b91c1c" : "#047857",
                  fontSize: 12,
                  fontWeight: 700,
                  margin: "10px 0 0",
                }}
              >
                {newsletterStatus.message}
              </p>
            )}

            {/* Payments */}
            <div style={{ marginTop: 15 }}>
              <p style={{ fontSize: 12 }}>🔒 Safety Payments</p>
              <div style={payments}>
              </div>
             <span><img src={Visa} alt="Visa" /></span>
            </div>
          </div>

        </div>

        {/* Bottom */}
        <div style={bottomSection}>
          <span>© 2026 Copyright | Bobbin USA | All Rights Reserved</span>
          <span>
            Powered By <b>Design Verse Studios</b>
          </span>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
